const state = {
    snackbar: {
        show: false,
        color: "",
        text: "",
        timeout: 5000,
    }
};

const getters = {
    snackbar: (state) => state.snackbar,
};

const actions = {
    showSnackbar({commit}, payload){
        commit("setSnackbar", payload);
    },
    hideSnackbar({commit}){
        commit("setHideSnackbar");
    }
};

const mutations = {
    setSnackbar: (state, snackbar) => {
        state.snackbar = snackbar;
    },
    setHideSnackbar: (state) => {
        state.snackbar.show = false;
    }
    
};

export default {
    state,
    getters,
    actions,
    mutations
}
